<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div
  class="d-flex flex-wrap xrx-pagination-wrapper justify-content-center justify-content-sm-end"
  role="navigation">
  <ngb-pagination
    [collectionSize]="collectionSize"
    [(page)]="page"
    [pageSize]="pageSize"
    (pageChange)="ngbPaginationChange($event)">
    <ng-template ngbPaginationPrevious>
      <span class="xgl-navigate_left" aria-hidden="true"></span>
    </ng-template>
    <ng-template ngbPaginationPages let-page let-pages="pages">
      @if (pages.length > 0) {
        <li class="ngb-custom-pages-item">
          <div class="d-flex flex-nowrap">
            <xrx-select
              [list]="generatePageList(pages)"
              property="page"
              localize="pageLabel"
              [(selectedItem)]="pageSelect"
              (change)="selectPage($event)">
            </xrx-select>
          </div>
        </li>
      }
    </ng-template>
    <ng-template ngbPaginationNext>
      <span class="xgl-navigate_right" aria-hidden="true"></span>
    </ng-template>
  </ngb-pagination>
  @if (pageSizeList !== null) {
    <xrx-select
      [list]="pageSizeList"
      property="size"
      localize="size"
      [(selectedItem)]="pageSizeSelect"
      (change)="selectPageSize($event)"
      class="ml-sm-3">
    </xrx-select>
  }
</div>
